import { useAtom } from "jotai"
import { userDetailsAtom } from "../../../components/Menu/menu.store"
import { useEffect, useState } from "react"
import { type ViewUserFmPsQuery, useViewUserFmPsLazyQuery } from "../../../type-and-hooks"
import { type ApolloError } from "@apollo/client"

interface FMPProjectsInterface {
  data: ViewUserFmPsQuery | undefined
  loading: boolean
  error: ApolloError | undefined | string
}
// ToDo change the interface with graphql once the api is ready.
export const useAddToFMPData = (loginNotRequired: boolean = true): FMPProjectsInterface => {
  const [userDetails] = useAtom(userDetailsAtom)
  const [customError, setCustomError] = useState<string | null>(null)
  const [fetchViewUserFMP, { data, loading, error }] = useViewUserFmPsLazyQuery()

  useEffect(() => {
    // Load fetchViewUserFMP only if userDetails is not null on page load
    const userID = userDetails?._id ?? null

    if (userID) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      fetchViewUserFMP({ variables: { userId: userID } })
    }
    if (!userID && !loginNotRequired) {
      setCustomError("User not logged in")
    }
  }, [userDetails, fetchViewUserFMP])

  return {
    data,
    loading,
    error: customError ?? error
  }
}
